import dynamic from 'next/dynamic'
import React from 'react'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { Colors } from 'src/components/theme'

const DemographicsContent = dynamic(() => import('src/components/insights/demographics/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const DemographicsPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props

  return (
    <InsightContainer insight={insight} color={Colors.blueDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        <DemographicsContent />
      </React.Suspense>
    </InsightContainer>
  )
}

export const Demographics: Insight = {
  id: 'demographics',
  component: DemographicsPage,
  name: 'Demographics',
  icon: DemographicsIcon,
  supportedResultTypes: ['venue', 'address', 'area', 'alphamap-location'],
  linkTooltipFile: 'insights-link-demographics',
  tier: INSIGHTS_TIER['Demographics'],
}
